module.exports = __webpack_public_path__ + "img/a8.b4060006.jpg";